import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcClose16Icon, IcReplyIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { FAB, IconView } from '@gem/ui-kit';

import { MiniatureQuotedMessage } from 'APP/main/ChatView/components/MiniatureQuotedMessage/MiniatureQuotedMessage';

import { useQuotedTextPresenter } from './QuotedText.presenter';
import styles from './QuotedText.styles.m.css';

interface IQuotedMessageProps {
  className?: string;
}

export const QuotedText: FC<IQuotedMessageProps> = observer(({ className }) => {
  const presenter = useQuotedTextPresenter();

  if (!presenter.isQuoteTextMode) {
    return null;
  }

  return (
    <div className={className}>
      <AddKeyPressHandler onEsc={presenter.endQuote} />
      <IconView
        Icon={IcReplyIcon}
        className={styles.icon}
      />
      <div className={styles.miniature}>
        <MiniatureQuotedMessage
          titleClassName={styles.miniatureTitle}
          textClassName={styles.miniatureText}
          iconClassName={styles.miniatureIcon}
          onClick={presenter.onClick}
          preventInteraction={presenter.isForwarding}
          title={<p className={styles.title}>{presenter.title}</p>}
          quote={presenter.quote}
        />
      </div>
      <FAB
        Icon={IcClose16Icon}
        size="10"
        iconSize="0"
        theme="12"
        onClick={presenter.endQuote}
        className={styles.remove}
      />
    </div>
  );
});
